import React, {Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Card, CardBody, CardTitle, Row, Col} from "reactstrap";
import {requestWidgets} from "../../../redux/Actions/tsdb.actions";
import {getWidgets} from "../../../redux/Selectors/tsdb.selector";
import "./hero.scss";

const getColor = (number) => {
  switch (number % 4) {
    case 0:
      return "bg-danger";
    case 1:
      return "bg-info";
    case 2:
      return "bg-yellow";
    case 3:
      return "bg-warning";
  }
};

const Hero = () => {
  const dispatch = useDispatch();
  const WidgetDetails = useSelector(getWidgets);
  useEffect(() => {
    dispatch(requestWidgets());
  }, [dispatch]);
  return (
    <Fragment>
      {WidgetDetails && WidgetDetails.length > 0 && (
        <div className="dashboard-header">
          <Row>
            {WidgetDetails.map((widget, index) => {
              const {main_text, main_value, main_icon} = widget || {};
              return (
                <Fragment key={index}>
                  <Col lg="4" xl="3" md="6" sm="12">
                    <Card
                      className="card-stats mb-4 mb-xl-0"
                      style={{borderRadius: "1.5rem"}}
                    >
                      <CardBody
                        className="dashboard-header-card"
                        style={{borderColor: "#00AFFF", borderWidth: "1px"}}
                      >
                        <Row>
                          <div className="col">
                            <CardTitle
                              tag="h5"
                              className="text-uppercase text-muted mb-0"
                            >
                              {main_text}
                            </CardTitle>
                            <span className="h2 font-weight-bold mb-0">{main_value}</span>
                          </div>
                          <Col className="col-auto">
                            <div
                              className={`icon icon-shape ${getColor(
                                index
                              )} text-white rounded-circle shadow `}
                            >
                              <i className={`${main_icon}`} />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Fragment>
              );
            })}
          </Row>
        </div>
      )}
    </Fragment>
  );
};

export default Hero;
